import * as _ from 'lodash';
import * as C from '../../../../assets/js/_constants';

const SETTINGS_DEFAULT = {
  config: {
    style: null,
    design: {
      params: {},
      settings: {
        'pre-order-button': {},
        'pre-order-message': {},
        'pre-order-button-hover': {}
      },
      template: ''
    },
    visible: 'always',
    buttonCss: '',
    parsedCss: '',
    customCss: '',
    selectors: {
      index: {
        selector: ''
      },
      product: {
        selector: ''
      },
      quickview: {
        selector: ''
      },
      collection: {
        selector: ''
      }
    },
    selectors_discount: {
      index: {
        price_product: ''
      },
      product: {
        price_product: ''
      },
      quickview: {
        price_product: ''
      },
      collection: {
        price_product: ''
      },
      cart: {
        price_individual: '',
        price_total: '',
        price_subtotal: ''
      },
      ajax_cart: {
        price_individual: '',
        price_total: '',
        price_subtotal: '',
        button_checkout: ''
      },
      hasShopAjaxCart: false
    },
    preOrderTag: '',
    parsedAtcStyle: {},
    selectedPosition: '',
    preOrderLimitWarning: '',
    disabledPreOrderStatus: 'noChanges',
    partiallyPreOrderWarning: '',
    checkoutWarning: ''
  },
  defaultSetting: {
    config: {
      buttonText: '',
      buttonMessage: '',
      hasCustomCheckoutLabel: false,
      preOrderLabel: '',
      quantityLimit: 0,
      closedPreOrderMessage: ''
    },
    date_start: null,
    date_stop: null,
    discount: {
      value: 0,
      type: C.DISCOUNT_TYPE_PERCENTAGE
    }
  },
  timezone: '',
  products: [],
  variants: []
};

export default class Settings {
  /**
   * @type {string}
   */
  #appName;

  /**
   * @param {string} appName
   */
  constructor(appName) {
    this.#appName = appName;
  }

  /**
   *
   */
  init() {
    let isSettingsSet = (
      typeof (Spurit) !== 'undefined' &&
      typeof (Spurit[this.#appName]) !== 'undefined' &&
      typeof (Spurit[this.#appName].settings) !== 'undefined'
    );

    let settings = SETTINGS_DEFAULT;
    if (isSettingsSet) {
      let settingsFromCDN = this.#preConvertRawSettingsFromCDN(Spurit[this.#appName].settings);
      settings = _.defaultsDeep(_.cloneDeep(settingsFromCDN), settings);
    }
    for (let key in settings) {
      this[key] = settings[key];
    }

    this.#postConvert();
  }

  /**
   * @param {{}} settingsFromCDN
   * @return {{}}
   */
  #preConvertRawSettingsFromCDN(settingsFromCDN) {
    if (settingsFromCDN.config && settingsFromCDN.config.selectors_discount) {
      // Convert 'config.selectors_discount':
      //    from {"page": "item": {selector: 'bla', position: ''}} to {"page": "item": 'bla'}
      let selectorsFromCDN = settingsFromCDN.config.selectors_discount;
      Object.entries(SETTINGS_DEFAULT.config.selectors_discount).forEach(([key1, selectors]) => {
        if (typeof (selectors) !== 'object') {
          return;
        }
        Object.keys(selectors).forEach(key2 => {
          if (typeof (selectorsFromCDN[key1]) === 'undefined' || typeof (selectorsFromCDN[key1][key2]) === 'undefined') {
            return;
          }
          if (typeof (selectorsFromCDN[key1][key2]) === 'string') {
            return;
          }
          if (selectorsFromCDN[key1][key2] && typeof (selectorsFromCDN[key1][key2].selector) === 'string') {
            selectorsFromCDN[key1][key2] = selectorsFromCDN[key1][key2].selector;
            return;
          }
          selectorsFromCDN[key1][key2] = '';
        });
      });
      settingsFromCDN.config.selectors_discount = selectorsFromCDN;
    }

    // Convert variant-, product- and default-discounts from {discount_type: ..., discount_value: ...} to {discount: {type: ..., value: ...}}
    if (typeof (settingsFromCDN.variants) === 'object') {
      Object.values(settingsFromCDN.variants).forEach(variant => {
        if (typeof (variant.discount_type) !== 'undefined' && typeof (variant.discount_value) !== 'undefined') {
          variant.discount = {
            type: variant.discount_type,
            value: variant.discount_value
          };
          delete (variant.discount_type);
          delete (variant.discount_value);
        }
      });
    }
    if (typeof (settingsFromCDN.products) === 'object') {
      Object.values(settingsFromCDN.products).forEach(product => {
        if (typeof (product.discount_type) !== 'undefined' && typeof (product.discount_value) !== 'undefined') {
          product.discount = {
            type: product.discount_type,
            value: product.discount_value
          };
          delete (product.discount_type);
          delete (product.discount_value);
        }
      });
    }
    if (typeof (settingsFromCDN.defaultSetting.discount_type) !== 'undefined' && typeof (settingsFromCDN.defaultSetting.discount_value) !== 'undefined') {
      settingsFromCDN.defaultSetting.discount = {
        type: settingsFromCDN.defaultSetting.discount_type,
        value: settingsFromCDN.defaultSetting.discount_value
      };
      delete (settingsFromCDN.defaultSetting.discount_type);
      delete (settingsFromCDN.defaultSetting.discount_value);
    }

    return settingsFromCDN;
  }

  /**
   *
   */
  #postConvert() {
    if (this.date_start) {
      this.date_start = new Date(this.date_start);
    }
    if (this.date_stop) {
      this.date_stop = new Date(this.date_stop);
    }
  }
}